export default __webpack_public_path__ + "static/media/ico-reception.73df5d3f.svg";